module.exports = __webpack_public_path__ + "static/img/shop_front_2.02e9220b.jpg";